import { Layout } from 'react-admin';
import { Box } from '@mui/material';
import { RostaMenu } from './RostaMenu';
import { RostaAppBar } from './RostaAppBar';
import { BreadcrumbProvider } from '../ui/Breadcrumb';
import { Breadcrumb } from '../ui/Breadcrumb/Breadcrumb';
import { PageTransition } from '@/components/PageTransition';

export const RostaLayout = ({ children }: { children: React.ReactNode }) => (
  <BreadcrumbProvider>
    <Layout
      menu={RostaMenu}
      appBar={RostaAppBar}
      sx={{ '& .RaLayout-contentWithSidebar': { pt: '64px' } }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        <Breadcrumb />
        <Box sx={{ flex: 1, overflow: 'auto', bgcolor: 'background.default' }}>
          <PageTransition>
            {children}
          </PageTransition>
        </Box>
      </Box>
    </Layout>
  </BreadcrumbProvider>
);
